import { commonService } from '.';

const getListMyConsultants = (body) => {
    return commonService.getWithParam('ListMyConsultant', body);
};

const updateEaEcheanceUser = (reference, dateEcheance, nextEaYear) => {
    return commonService.put('ListMyConsultant/updateEaEcheanceUser?reference=' + reference + '&dateEcheance=' + dateEcheance + '&nextEaYear=' + nextEaYear);
};

export const listeMyConsultantService = {
    getListMyConsultants,
    updateEaEcheanceUser
};
